import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, CarouselVariant, Image, I18N_NAMESPACES, Overlay } from '@as/cotopaxi';
import { ProductImageSizesPortraitEnum, } from '@as-react/common-types';
import { Box, Stack, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getPortraitImageSizeUrlByProductCode } from '../../../util/ImageUtil';
import LabelsOverlay from '../../common/labels-overlay/LabelsOverlay';
const LABELS_AMOUNT = 1;
const FIRST_IMAGE = 0;
export const MiniPDPImageCarousel = ({ images, productCode, productImageCdnDomains, isOutOfStock, hasAnotherAvailableColor, genderFeatureId, showGenderIcon, savingsPercentage, priceOverlay, showNewProductLabel, showOnlineExclusiveLabel, showSustainabilityLabel, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isMobile = useMediaQueryMatchesOnMobile();
    const imageCarouselConfig = {
        overlay: isOutOfStock && (_jsx(TextAlpha, { strong: true, alignment: "center", variant: isMobile ? 'bodyS' : 'bodyL', children: hasAnotherAvailableColor ? t('wishlist.outOfStock.other.color.available') : t('product.temporarilyOutOfStock') })),
        variant: CarouselVariant.MINI_PDP_IMAGE,
        showPagination: false,
        configurationOverrides: {
            rebuildOnUpdate: true,
            preventClicks: true,
            slidesPerView: 'auto',
            watchOverflow: true,
            spaceBetween: 12,
            shouldSwiperUpdate: true,
            allowSlideNext: !isOutOfStock,
            allowSlidePrev: !isOutOfStock,
            allowTouchMove: !isOutOfStock,
        },
    };
    return useMemo(() => (_jsx(Carousel, Object.assign({}, imageCarouselConfig, { children: images.map((image, index) => {
            const imageUrl = getPortraitImageSizeUrlByProductCode(productCode, image.picture, productImageCdnDomains, ProductImageSizesPortraitEnum.basket);
            return (_jsxs("div", { className: "a:relative", children: [_jsx(Image, { src: imageUrl }), index === FIRST_IMAGE && (_jsx(Overlay, { noPointerEvents: true, stretchContent: true, children: _jsx(Stack, { align: "end", children: _jsx(Box, { paddingBlockEnd: "1", children: _jsx(LabelsOverlay, { maxLabels: LABELS_AMOUNT, showGenderIcon: showGenderIcon, genderFeatureId: genderFeatureId, savingsPercentage: savingsPercentage, priceOverlay: priceOverlay, showNewProductLabel: showNewProductLabel, showOnlineExclusiveLabel: showOnlineExclusiveLabel, showSustainabilityLabel: showSustainabilityLabel, dataQA: "mini_pdp_product_image_overlay" }) }) }) }))] }, imageUrl));
        }) }))), [isOutOfStock, images]);
};
